import React, { ReactElement } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";

import {
  Alert,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Answer, Question } from "../types";

interface Props {
  question: Question;
  handleAnswerSelect: (data: {
    answer: string;
    correctAnswer: string;
    questionId: string;
  }) => void;

  handleNextButtonClick: () => void;
  handleBackButtonClick: () => void;
  currentAnswer: Answer | null;
  showRemarks: boolean;
}

export function QuestionItem({
  question,
  handleAnswerSelect,
  handleNextButtonClick,
  handleBackButtonClick,
  currentAnswer,
  showRemarks,
}: Props): ReactElement {
  const mapAnswerStringToArray = (str: string) =>
    str
      .split("")
      .filter((char) => char !== "[" && char !== "]")
      .join("")
      .split(",");

  return (
    <>
      <Typography>{question.Question}</Typography>
      <FormControl component="fieldset">
        <RadioGroup
          value={currentAnswer?.[question.Id]}
          name="radio-buttons-group"
          onChange={(e) =>
            handleAnswerSelect({
              answer: e.target.value,
              correctAnswer: question.Correct_Answer,
              questionId: question.Id,
            })
          }
        >
          {mapAnswerStringToArray(question.Available_Options).map((answer) => {
            return (
              <FormControlLabel
                key={answer}
                value={answer}
                control={
                  <Radio
                    sx={{
                      color: "#0D548A",

                      "& .MuiSvgIcon-root": {
                        fontSize: 15,
                      },
                      "&.Mui-checked": {
                        color: "#0D548A",
                      },
                    }}
                    value={answer}
                    onClick={() => {
                      if (currentAnswer && answer === question.Correct_Answer) {
                        handleNextButtonClick();
                      }
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: "0.83rem",
                      marginLeft: "0.4rem",
                    }}
                  >
                    {answer}
                  </Typography>
                }
              />
            );
          })}
        </RadioGroup>
      </FormControl>
      {
        <>
          {showRemarks && (
            <Alert
              variant="filled"
              sx={{ bgcolor: "rgba(13,84,138, 0.6)" }}
              severity="warning"
            >
              {question.Remarks}
            </Alert>
          )}
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              onClick={handleBackButtonClick}
              sx={{
                bgcolor: "#0D548A",
                marginTop: "1.5rem",
                width: "7rem",
                "&:hover": {
                  backgroundColor: "#0D548A",
                },
              }}
            >
              Go Back
            </Button>

            {showRemarks && (
              <Button
                variant="contained"
                startIcon={<CheckIcon />}
                onClick={handleNextButtonClick}
                sx={{
                  bgcolor: "#0D548A",
                  marginTop: "1.5rem",
                  width: "7rem",
                  "&:hover": {
                    backgroundColor: "#0D548A",
                  },
                }}
              >
                Next
              </Button>
            )}
          </Box>
        </>
      }
    </>
  );
}
